import { ColDef } from '@material-ui/data-grid';

export const contentToColumns: ColDef[] = [
  {
    field: 'title',
    headerName: 'Title',
    width: 300,
    renderCell: (params) => (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <span>{params.row.title || params.row.original_title}</span>
      </div>
    ),
  },
  {
    field: 'vtr_id',
    headerName: 'VTR ID',
    width: 150,
  },
  {
    field: 'content_type',
    headerName: 'Type',
    width: 120,
  },
  {
    field: 'release_year',
    headerName: 'Release Year',
    width: 120,
  },
  {
    field: 'genres',
    headerName: 'Genres',
    width: 200,
  },
  {
    field: 'poster_path',
    headerName: 'Poster',
    width: 100,
    renderCell: (params) => (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        {params.row.poster_path ? (
          <img 
            src={params.row.poster_path} 
            alt="Poster" 
            style={{ width: 40, height: 60, objectFit: 'cover' }}
          />
        ) : (
          <span>No poster</span>
        )}
      </div>
    ),
  },
]; 